import buildTestScoreHistogramChart from '../../utils/buildTestScoreHistogramChart';

export default buildTestScoreHistogramChart;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/charts/selectedtraining/sttest_result_users.js